import { render, staticRenderFns } from "./GzzjwhBrowse.vue?vue&type=template&id=5501e2a0"
import script from "./GzzjwhBrowse.vue?vue&type=script&lang=js"
export * from "./GzzjwhBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports